import {App} from "vue";
import Hammer from "hammerjs";

export default {
  install(vueApp: App<Element>) {
    vueApp.directive('swipe-right', {
      mounted(el, binding, vnode, prevVnode) {
        const hammer = new Hammer(el);
        hammer.on('swiperight', binding.value);
      },
    });

    vueApp.directive('swipe-left', {
      mounted(el, binding, vnode, prevVnode) {
        const hammer = new Hammer(el);
        hammer.on('swipeleft', binding.value);
      },
    });
  },
};